// Sidebar.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Calendar, Package, LogOut, Menu, X, Gift, GraduationCap } from 'lucide-react';

const Sidebar = ({ activeTab, setActiveTab, isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    window.location.reload();
  };

  const navigationItems = [
    {
      id: 'bookings',
      label: 'Bookings',
      icon: Calendar,
      path: '/admin/bookings'
    },
    {
      id: 'orders',
      label: 'Orders',
      icon: Package,
      path: '/admin/orders'
    },
    {
      id: 'coupons',
      label: 'Coupons',
      icon: Gift,
      path: '/admin/coupons'
    },
    {
      id: 'academy',
      label: 'Academy',
      icon: GraduationCap,
      path: '/admin/academy'
    }
  ];

  const NavButton = ({ item, isLast = false }) => (
    <button
      onClick={() => {
        setActiveTab(item.id);
        navigate(item.path);
      }}
      className={`flex items-center text-gray-300 hover:bg-gray-700 py-2 px-3 rounded w-full ${
        !isLast ? 'mb-2' : ''
      } ${isOpen && location.pathname === item.path ? 'bg-gray-700' : ''} ${
        !isOpen ? 'justify-center' : ''
      }`}
      title={!isOpen ? item.label : ''}
    >
      <item.icon className={isOpen ? 'mr-3' : ''} size={28} />
      {isOpen && item.label}
    </button>
  );

  return (
    <div className={`bg-gray-800 h-screen fixed left-0 top-0 z-50 transition-all duration-300 ${
      isOpen ? 'w-40' : 'w-5'
    }`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="absolute right-0 top-0 mt-6 bg-gray-800 rounded-full p-1.5 transform hover:bg-gray-600 z-50"
        style={{ right: '-12px' }}
      >
        {isOpen ? (
          <X className="text-gray-300 transition-transform duration-200 hover:rotate-90" size={24} />
        ) : (
          <Menu className="text-gray-300" size={24} />
        )}
      </button>
      
      <div className="p-4 pt-16">
        {isOpen && (
          <h2 className="text-white text-xl font-bold mb-8">Dashboard</h2>
        )}
        <nav className="flex flex-col items-center">
          {/* Main navigation items */}
          {navigationItems.map((item) => (
            <NavButton key={item.id} item={item} />
          ))}
          
          {/* Logout button */}
          <button
            onClick={handleLogout}
            className={`flex items-center text-gray-300 hover:bg-gray-700 p-3 rounded w-full mt-8 ${
              !isOpen ? 'justify-center' : ''
            }`}
            title={!isOpen ? 'Logout' : ''}
          >
            <LogOut className={isOpen ? 'mr-3' : ''} size={28} />
            {isOpen && 'Logout'}
          </button>
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;